import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { DocumentNumberSettingsComponent } from './document-number-settings.component';
import { RnplCommonModule } from 'common/src/modules';
import { UIComponentsModule } from 'common/src/modules';

@NgModule({
  declarations: [
    DocumentNumberSettingsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UIComponentsModule,
    TranslateModule,
    NgSelectModule,
    RnplCommonModule,
  ],
  exports: [
    DocumentNumberSettingsComponent,
  ],
  providers: []
})
export class DocumentNumberSettingsModule { }
